import LivedigitalSDKError from './LivedigitalSDKError';

class UnsupportedError extends LivedigitalSDKError {
  static readonly UNSUPPORTED_DEVICE_CODE = 'unsupported_device_error';

  static readonly UNSUPPORTED_OPERATION_CODE = 'unsupported_operation_error';

  static readonly DEFAULT_MESSAGE = 'Unsupported operation';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? UnsupportedError.DEFAULT_MESSAGE, errorCode ?? 'unsupported_error', meta);
  }
}

export default UnsupportedError;
